// Constants for promotions
export const PromotionType = Object.freeze({
  STORE_DISCOUNT: 'STORE_DISCOUNT',
  WELCOME_DISCOUNT: 'WELCOME_DISCOUNT',
  BUY_PRODUCT: 'BUY_SINGLE_PRODUCT',
  BUY_MULTIPLE: 'BUY_MULTIPLE_PRODUCTS',
})

// BuyType constants - updated to match the new API format keys
export const BuyType = Object.freeze({
  CATEGORY: 'CATEGORY',
  BRAND: 'BRAND',
  PRODUCT: 'PRODUCTS',
  PRODUCT_ID: 'PRODUCT_ID',
  GTINS: 'GTIN',
  COMBO_ID: 'COMBO_ID'
})

export const CategoryTabTypes = Object.freeze({
  CATEGORY: 'CATEGORY',
  BRAND: 'BRAND',
  PRODUCT: 'PRODUCTS',
  PRODUCT_ID: 'PRODUCT_ID',
  GTINS: 'GTIN',
})

// These constants are now defined in the API response

export const PRODUCT_ID_TYPE = 'PRODUCT_ID'

export const COMBO_ID_TYPE = 'COMBO_ID'

export const GTIN_TYPE = 'GTIN'

export const RewardTypes = Object.freeze({
  DISCOUNT: 'DISCOUNT',
  FREE_PRODUCT: 'FREE_PRODUCT',
  GIFT_ITEM: 'GIFT_ITEM',
  POINTS: 'POINTS',
  FREE_PRODUCT_FROM_LIST: 'FREE_PRODUCT_FROM_LIST',
  PERCENTAGE_DISCOUNT: 'PERCENTAGE_DISCOUNT',
  CASH_DISCOUNT: 'CASH_DISCOUNT',
})

export const GiftItemTypes = Object.freeze({
  VOUCHER: 'VOUCHER',
})

export const SegmentTypesOld = Object.freeze({
  SELECTED_GROUPS: 'SELECTED_GROUPS',
  SELECTED_SEGMENTS: 'SELECTED_SEGMENTS',
  ALL_CUSTOMERS: 'ALL_CUSTOMERS',
})

export const SegmentTypes = Object.freeze({
  SEGMENT_FOLDER: 'SEGMENT_FOLDER',
  SEGMENT_LIST: 'SEGMENT_LIST',
  ALL_CUSTOMERS: 'ALL_CUSTOMERS',
})

export const DisplayOnTypes = Object.freeze({
  HOME_PAGE: 'HOME_PAGE',
  PRODUCT_PAGE: 'PRODUCT_PAGE',
  PRODUCT_CARD: 'PRODUCT_CARD',
  PRODUCT_CATALOGUE: 'PRODUCT_CATALOGUE',
})

export const displayOnMapping = Object.freeze({
  HOME_PAGE: 'Homepage',
  PRODUCT_PAGE: 'Product Page',
  PRODUCT_CARD: 'Product Card',
  PRODUCT_CATALOGUE: 'Product Catalogue',
})

//Dropdown inputs

export const buyOptions = [
  {displayText: '1', id: '1'},
  {displayText: '2', id: '2'},
  {displayText: '3', id: '3'},
]

export const ANY_ID = 'ANY'

export const ANY_BUY_OPTION = {displayText: 'Any', id: ANY_ID, uom: ''}

export const buyTypeOptions = [
  {displayText: 'Category', id: BuyType.CATEGORY},
  {displayText: 'Brand', id: BuyType.BRAND},
  {displayText: 'Product', id: BuyType.PRODUCT},
  {displayText: 'Product id', id: BuyType.PRODUCT_ID},
  {displayText: 'Gtins', id: BuyType.GTINS},
]

export const rewardOptions = [
  {displayText: 'Discount', id: RewardTypes.DISCOUNT},
  {displayText: 'Free product', id: RewardTypes.FREE_PRODUCT},
  {displayText: 'Gift item', id: RewardTypes.GIFT_ITEM},
  {displayText: 'Points', id: RewardTypes.POINTS},
  {displayText: 'Free product from list', id: RewardTypes.FREE_PRODUCT_FROM_LIST},
  {displayText: 'Percentage discount', id: RewardTypes.PERCENTAGE_DISCOUNT},
  {displayText: 'Cash discount', id: RewardTypes.CASH_DISCOUNT},
]

export const giftItemOptions = [{displayText: 'Voucher', id: GiftItemTypes.VOUCHER}]

// Dropdown options for Free Product reward – only Product ID and GTIN
export const freeProductTypeOptions = [
  {displayText: 'Product ID', id: BuyType.PRODUCT_ID},
  {displayText: 'GTIN', id: BuyType.GTINS},
]

export const segmentOptions = [
  // {displayText: 'Create New Segment', id:'Create New Segment'},
  {displayText: 'Segment Folder', id: SegmentTypes.SEGMENT_FOLDER},
  {displayText: 'Segment List', id: SegmentTypes.SEGMENT_LIST},
]

export const excludedSegmentOptions = [
  {displayText: 'Segment Folder', id: SegmentTypes.SEGMENT_FOLDER},
  {displayText: 'Segment List', id: SegmentTypes.SEGMENT_LIST},
]

export const PromotionContionsTabList = [
  {
    tabLabel: 'Units',
    id: 'UNITS',
    uom: 'UN',
  },
  {
    tabLabel: 'Cases',
    id: 'CASES',
    uom: 'CT',
  },
  {
    tabLabel: 'Amount',
    id: 'AMOUNT',
    uom: 'EA',
  },
]

export const LOCATION_OPTIONS = [
  {displayText: 'Home Page', id: 'HOME_PAGE'},
  {displayText: 'Promotions Main Page', id: 'PROMOTIONS_MAIN_PAGE'},
  {displayText: 'Product Proof', id: 'PRODUCT_PROOF'},
  {displayText: 'Product Card', id: 'PRODUCT_CARD'},
  {displayText: 'Product Catalogue', id: 'PRODUCT_CATALOGUE'},
]

export const DISPLAY_ORDER_OPTIONS = [
  {displayText: '1', id: '1'},
  {displayText: '2', id: '2'},
  {displayText: '3', id: '3'},
  {displayText: '4', id: '4'},
  {displayText: '5', id: '5'},
]

export const mockLanguages = [
  {code: 'en', language: 'English'},
  {code: 'es_MX', language: 'Spanish (Mexico)'},
]
// Tab configurations are now fetched from the API
